import styled from 'styled-components';
import { IThemeProvider } from '../../styles/theme';

export const ProgressSpinnerCont = styled.div`
   display: flex;
   flex-direction: column;
   position: relative;
   width: auto;
`;

export const SpinnerMetaDataCont = styled.div`
  display: flex;
  justify-content: space-between;
  ${({theme}: IThemeProvider) => `
      margin:  ${theme.layout.spacing.mikro} 0 0 0;
  `};
`;
